module.exports = __webpack_public_path__ + "img/lso.c0799ebf.svg";